exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1aLbWPZaoqATP5Xjzmr0S0{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._1aLbWPZaoqATP5Xjzmr0S0{margin:10px 0 11px 0}._32KeZnu8gPGu0ZwnQy0zw-{display:-webkit-box;display:-ms-flexbox;display:flex;width:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0}.GgZgEHJPARE8ZtRhCCalZ{color:var(--neutralSecondary);font-size:17px}._1qCKL06JP91F3bLJMFiDZs{overflow-x:hidden}.R1VyRG_vGx0sQm1F4j6od{line-height:20px}html[dir] .R1VyRG_vGx0sQm1F4j6od{margin-bottom:8px}._3PfksQuBT9MijW8ETJ_yaS{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
exports.locals = {
	"fullComposeRow": "_1aLbWPZaoqATP5Xjzmr0S0",
	"iconContainer": "_32KeZnu8gPGu0ZwnQy0zw-",
	"icon": "GgZgEHJPARE8ZtRhCCalZ",
	"container": "_1qCKL06JP91F3bLJMFiDZs",
	"detailContainer": "R1VyRG_vGx0sQm1F4j6od",
	"detailContentContainer": "_3PfksQuBT9MijW8ETJ_yaS"
};